import App from 'app/app.js';

function LtClickDirective($document) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      $document.bind('click', function (e) {
        if (e.target.id !== 'priceLink' && angular.element(document.querySelector('.popover')).is(':visible')) {
          angular.element(document.querySelector('#priceLink')).click();
        }
      });
    }
  };
}

App.directive('ltClick', ['$document', LtClickDirective]);
